export const secondaryWholesalers = ['bluepax_secondary',
    // Secondary Insert
    'capital_secondary',
    'rx_supply_secondary',
    'bloodworth_secondary',
    'keysource_secondary',
    'toprx_secondary',
    'auburn_secondary',
    'ipc_secondary',
    'quest_secondary',
    'masters_secondary',
    'mutual_drug_secondary'];
export var WholesalerKeys;
(function (WholesalerKeys) {
    WholesalerKeys["BLUPAX"] = "bluepax_secondary";
    WholesalerKeys["CAPITAL"] = "capital_secondary";
    WholesalerKeys["RXSUPPLY"] = "rx_supply_secondary";
    WholesalerKeys["BLOODWORTH"] = "bloodworth_secondary";
    WholesalerKeys["KEYSOURCE"] = "keysource_secondary";
    WholesalerKeys["TOPRX"] = "toprx_secondary";
    WholesalerKeys["AUBURN"] = "auburn_secondary";
    WholesalerKeys["IPC"] = "ipc_secondary";
    WholesalerKeys["QUEST"] = "quest_secondary";
    WholesalerKeys["MASTERS"] = "masters_secondary";
    WholesalerKeys["MUTUALDRUG"] = "mutual_drug_secondary";
    WholesalerKeys["MCKESSON"] = "mckesson_primary";
    WholesalerKeys["CARDINAL"] = "cardinal_primary";
    // PM-2035: Cencora is the 2023 rebrand of AmerisourceBergen, not a second
    // wholesaler. The enum previously carried BOTH `amerisource_primary` and
    // `cencora_primary`; the legacy key is gone and this is the single canonical one.
    // Neither key had a wholesalers sub-schema, so 0 of 1248 prod wholesaler documents
    // carried either — see the migration for the compliance-collection rename.
    WholesalerKeys["CENCORA"] = "cencora_primary";
    WholesalerKeys["KINRAY"] = "kinray_primary";
    WholesalerKeys["MORRISDICKSON"] = "morris_dickson_primary";
})(WholesalerKeys || (WholesalerKeys = {}));
export const primaryWholesalers = ['mckesson_primary',
    // Primary Insert
    'cardinal_primary',
    'kinray_primary',
    'cencora_primary',
    'morris_dickson_primary',
];
export const isPrimaryWholesaler = (wholesaler) => {
    return primaryWholesalers.includes(wholesaler);
};
export const wholesalers = [...secondaryWholesalers, ...primaryWholesalers];
